

export default{
    name: 'NotCertify',
    created() {
        
    },

    methods: {
        
    },
    data() {
        return {
            usertype: _global.userInfo.usertype,
            userInfo: _global.userInfo,
        }
    },
}